import { render, staticRenderFns } from "./JSNavigation.vue?vue&type=template&id=59d020be&scoped=true&"
import script from "./JSNavigation.vue?vue&type=script&lang=js&"
export * from "./JSNavigation.vue?vue&type=script&lang=js&"
import style0 from "./JSNavigation.vue?vue&type=style&index=0&id=59d020be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d020be",
  null
  
)

export default component.exports